import React, { useState, useEffect } from "react";
import { Progress, Row, Col } from 'antd';
import { getQuestionName, getQuizName, calcTotalNumQuestions } from "lib";
import { fetchQuizLocal, } from 'quizdb';
import FormItem from "antd/es/form/FormItem";
import Text from 'antd/es/typography/Text';

export default (props) => {
  const {
    questionComplete,
    questionsIndex,
  } = props;

  const quizName = getQuizName();
  const quiz = fetchQuizLocal(quizName);
  const questionName = getQuestionName();
  let questionNames = Object.keys(quiz);
  const questionNameIndex = questionNames.indexOf(questionName);
  const finishPageIndex = questionNames.findIndex((name) => name === "Finish Page");
  if (finishPageIndex > -1 ) questionNames.splice(finishPageIndex, 1);

  const numQuestions = questionNames.length;
  const current = questionsIndex+Number(questionComplete);
  const percent = Math.floor(current / (numQuestions) * 100);

  return (
    <FormItem>
      <Row type="flex" justify="center" align="middle">
        <Col pull={1}>
          <Text type="secondary">Quiz </Text>
          <Text type="primary">{quizName}</Text>
        </Col>
        <Col span={9}>
          <Progress showInfo={false} percent={percent} status="active" />
        </Col>
        <Col push={1}>
          <Text style={{ textAlign: 'center' }} level={4}>
            <Text type="secondary">Question </Text>
            <Text type="primary">{current} of {numQuestions} completed</Text>
          </Text>
        </Col>
      </Row>
    </FormItem>
  );
}